/**
 * wsr-api WStudio global-config client (WSRPDM-0023).
 *
 * The platform surface returns raw DTOs and is bearer-only. The shared
 * request primitive supplies the in-memory bearer and bounded 401 refresh;
 * unlike saas-auth writes, this PUT intentionally carries no CSRF token.
 */
import { request } from '../client';

export interface WStudioGlobalKey {
  key: string;
  value: string;
}

export interface WStudioGlobalConfig {
  active: boolean;
  keys: WStudioGlobalKey[];
}

export interface WStudioGlobalUpdate {
  active: boolean;
  entries: WStudioGlobalKey[];
}

const GLOBAL_CONFIG_PATH = '/admin/platform/wstudio/global-config';

export async function getGlobalConfig(): Promise<WStudioGlobalConfig> {
  return request<WStudioGlobalConfig>('GET', GLOBAL_CONFIG_PATH);
}

export async function putGlobalConfig(body: WStudioGlobalUpdate): Promise<WStudioGlobalConfig> {
  return request<WStudioGlobalConfig>('PUT', GLOBAL_CONFIG_PATH, { json: body });
}
